import {useState, useEffect} from 'react';
import { useStyles } from './styles';
import { Box, Button, Grid, TextField, TextareaAutosize, Typography, FormGroup, FormControl, Select, MenuItem, InputLabel, FormControlLabel, Checkbox, CircularProgress, Radio, RadioGroup, OutlinedInput, InputAdornment } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import CancelIcon from '@material-ui/icons/Cancel';
import IconButton from '@material-ui/core/IconButton';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { useTheme } from '@material-ui/core/styles';
import { encrypt } from '../../../helpers/encrypt';
import { checkValidEmail, isAdminCheck, getAppSource, getUserType, checkDigitOnly, renderDefaultMsg } from '../../../helpers';
import { submitContactMeRequest, getAllStateList } from '../../../actions';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import DateFnsUtils from '@date-io/date-fns';
import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers';
import close from '../../../assets/close.png';
import Cookies from 'js-cookie';

export const ContactMe = (props) => {

  const classes = useStyles();
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const [additionalNote, setAdditionalNote] = useState("");
  const [checkboxState, setCheckboxState] = useState(false);
  const [mobileNo, setMobileNo] = useState('');
  const [mobileNoErr, setMoileNoError] = useState("");
  const [errorMessage, setErrorMessage] = useState("")
  const [emailId, setEmailId] = useState('');
  const [emailError, setEmailError] = useState("");
  const [stateData, setStateData] = useState([]);
  const [selectedState, setSelectedState] = useState('');
  const [stateErrorMsg, setStateErrorMsg] = useState('');
  const [loanState, setLoanState] = useState('');
  const [addDescriptionStatus, setDescriptionStatus] = useState(false);
  const [mandatoryFields, setMandatoryFields] = useState(false);
  const [isSubmit, isSubmitStatus] = useState(false);
  const [loaderStatus, setloaderStatus] = useState(false);
  const [state, setState] = useState({
    lastName: '', state: '', firstName: '', email: '', mobile: '', dob: '', ssn: '', showssn: false, isBSI: '', military: ''
  });
  const [isOpen, setIsOpen] = useState(false);
  const [inputDate, setInputDate] = useState(null);
 
  useEffect(() => {
    getState();
  }, []);

  const checkboxChangeHandler = (event) => {
    setCheckboxState(event.target.checked)
  }

  const addDescription = () => {
    setDescriptionStatus(!addDescriptionStatus)
  }
  
  const handleMobileNo = (event) => {
    if (checkDigitOnly(event.target.value)) {
     setMobileNo(event.target.value)
    } 
  }

  const handleCommment = (event) => {
    setAdditionalNote(event.target.value)
  }

  const handleCancel= (status) => {
    props.closeCallMePopup(status)
  }

  const handleFormStateChange = (event) => {
    setSelectedState(event.target.value);
  }

   const dateFormat = (selectedDate) => {
    if (selectedDate) {
      let dt = new Date(selectedDate)
      return `${dt.getMonth() + 1}/${dt.getDate()}/${dt.getFullYear()}`
    } else {
      return ''
    }
  }
 
  const handleConfirm = async () => {
    if (checkValidations()) {
      setMandatoryFields(true)
    } else {
      setloaderStatus(true)
      setMandatoryFields(false)

      const data = {
        "last4SSN": encrypt(state.ssn),
        'dob': inputDate ? encrypt(dateFormat(inputDate)) : null,
        "emailId": emailId ? encrypt(emailId) : null,
        "phoneNo": encrypt(mobileNo),
        "newLoanState": selectedState?.stateCode,
        "callbackReason": loanState,
        "isMilitaryVeteran": state.military == 'Yes' ? true : false,
        "firstName": state.firstName,
        "lastName": state.lastName,
        "isBSICustomer": state.isBSI == 'Yes' ? true : false,
        "isConsent": checkboxState,
        "description": additionalNote,
        "requestSource": "PreLogin",
        "privateLabelUrl": Cookies.get("privateLabelUrl"),
        "ipAddress": Cookies.get('publicIp'),
        "browser": Cookies.get("browser"),
        "appSource": getAppSource(),
        "userType": getUserType(),
        "userName": "PreLogin",
      };

      const response = await submitContactMeRequest(data);
      if (response) {
        setloaderStatus(false)
        if (response?.responseData?.lstResponseStatus && (response?.responseData?.lstResponseStatus[0]?.statusCode == 0)) {
          isSubmitStatus(true)
          setErrorMessage("")
        } else {
          setErrorMessage(renderDefaultMsg('400'))
        }
      } else {
        setloaderStatus(false)
        setErrorMessage(renderDefaultMsg('400'))
      }
    }
  }
  
  const calculateCommentLenth = () => {
    const length = additionalNote?.length
    if (isNaN(length)) {
      return 0
    } else {
      return length
    }
  }

  const validateMobileNo = (event) => {
    event.preventDefault()
    if (checkDigitOnly(event.target.value)) {
      if(event.target.value.length === 10) {
        setMoileNoError('');
      } else {
        setMoileNoError('Please enter valid phone number.')
      }
   }
  }

  const validateEmail = (event) => {
    event.preventDefault()
    if (checkValidEmail(event.target.value?.trim())) {
      setEmailError('');
    } else {
      setEmailError('Please enter valid email address.')
    }
  }

  const getState = async (e) => { 
    const response = await getAllStateList();
    if (response && response.lstResponseStatus && response.lstResponseStatus[0].statusCode == 0) {
      setStateErrorMsg('');
      setStateData(response.stateList);
    } else if (response && response.lstResponseStatus && response.lstResponseStatus[0].statusCode == 1001) {
      setStateErrorMsg(response.lstResponseStatus[0].statusDesc);
    } else {
      setStateErrorMsg(renderDefaultMsg('400'));
    }
  }

  const checkValidations = () => {
    if ((mobileNo == "") || (mobileNo?.trim().length === 0) || (mobileNoErr !== '') || (loanState == '') || (selectedState == '') || !checkboxState || (state.firstName == '') || (state.lastName == '') || (state.ssn == '') || (state.isBSI == '') || (state.military == '')) {
      return true
    } else {
      return false
    }
  }

  const handleSaveOnLoansChange = (event) => {
    setLoanState(event.target.value)
  }

  const handleEmailId = (event) => {
    setEmailId(event.target.value)
  }

  const handleRadioChange = (event, name) => {
    if (name == 'bsi') {
      setState({ ...state, ['isBSI']: event.target.value });
    } else {
      setState({ ...state, ['military']: event.target.value });
    }
  }

  const handleNameChange = (event) => {
    setState({ ...state, [event.target.name]: event.target.value });
  }

  const handleClickShowPassword = () => {
    setState({ ...state, showssn: !state.showssn });
  };

  const handleFormTextChange = (prop) => (event) => {
    if (prop === 'ssn') {
      if (!(/[^\w\s]/gi).test(event.target.value) && !(/\s/g).test(event.target.value)) {
        setState({ ...state, [event.target.name]: event.target.value.slice(0, 4) });
      }
      return;
    }
  }

  const handleDateChange = (filed) => (date) => {
    if (filed === "inputDate") {
      setInputDate(date);
      setIsOpen(false);
    }
  }

  return (
    
      <Dialog
        open={true}
        fullScreen={fullScreen}
        fullWidth
        maxWidth={false} 
        PaperProps={{
          classes: { root: classes.dialogStyle },
          style: { maxWidth: 'none', width: !isSubmit ? 940 : 540} 
        }}
      >
      <Box className={classes.root}>
        <IconButton  className={classes.closeIcon} onClick={() => handleCancel(false)}>
          <CancelIcon />
        </IconButton>
         <Box className={classes.cardTitleBody}>
           <Typography className={classes.statusTitle}>Request a Loan Consultation</Typography>
         </Box> 
         { !isSubmit ?
            <Box className={classes.cardBody}>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6} md={6}>
               <Box className={classes.marginFixed}>
                  <p className={classes.procedureToFill}>Are you an existing BSI customer? <span style={{ color: "red" }}>*</span></p>
                  <Box className={classes.radioBtn}>
                  <RadioGroup row  aria-label="isBSi" name="isBSi" 
                      onChange={(e) => handleRadioChange(e, 'bsi')}>
                      <FormControlLabel value="Yes" checked={state.isBSI == 'Yes' ? true : false}
                      control={<Radio />} label="Yes" />
                      <FormControlLabel value="No"
                      control={<Radio />} label="No" checked={state.isBSI == 'No' ? true : false}/>
        
                  </RadioGroup>
                </Box>
                </Box>
                </Grid>
                <Grid item xs={12} sm={6} md={6}>
                <Box className={classes.marginFixed}>
                  <p className={classes.procedureToFill}>Have you or your spouse served in the military? <span style={{ color: "red" }}>*</span></p>
                  <Box className={classes.radioBtn}>
                  <RadioGroup row  aria-label="military" name="military" 
                      onChange={(e) => handleRadioChange(e, 'military')}>
                      <FormControlLabel value="Yes" checked={state.military == 'Yes' ? true : false}
                      control={<Radio />} label="Yes" />
                      <FormControlLabel value="No" checked={state.military ==='No' ? true : false}
                      control={<Radio />} label="No" />
        
                  </RadioGroup>
                </Box>
                </Box>
                </Grid>
                <Grid item xs={12} sm={6} md={6}>
              <p className={classes.procedureToFill}>Save on Loans with Us! What’s your goal?  <span style={{ color: "red" }}>*</span></p>
              <FormControl variant="outlined" className={classes.formControl} style={{ width: '100%' }}>
              <InputLabel id="borrower-type-select-outlined">Select One</InputLabel>
              <Select
                labelId="request-outlined-label"
                id="request-select-outlined"
                color="primary"
                name="request"
                label="Select One"
                className={classes.inputStyle}
                fullWidth
                value={loanState}
                onChange={handleSaveOnLoansChange}
              >
                <MenuItem value="Buy a new home (purchase loan)">Buy a new home (purchase loan)</MenuItem>
                <MenuItem value="Lower my monthly payment">Lower my monthly payment</MenuItem>
                <MenuItem value="Reduce my interest rate">Reduce my interest rate</MenuItem>
                <MenuItem value="Reduce total loan cost">Reduce total loan cost</MenuItem>
                <MenuItem value="Pay off my loan faster">Pay off my loan faster</MenuItem>
                <MenuItem value="Refinance to a better loan">Refinance to a better loan</MenuItem>
                <MenuItem value="Not sure – need advice">Not sure – need advice</MenuItem>
              </Select>
              </FormControl>
            </Grid>
             <Grid item xs={12} sm={6} md={6}>
             <Box className={classes.textareaSection}>
              {(loanState !== '') && <p className={classes.procedureToFill}>{(loanState == "Buy a new home (purchase loan)") ? 'Property State for which you are taking new loan' : (loanState == "Not sure – need advice") ? 'Property State for refinancing or taking new loan' : 'Property State for refinancing'} <span style={{ color: "red" }}> *</span></p>}
               {(loanState == '') && <p className={classes.procedureToFill}>Property State for refinancing or taking new loan<span style={{ color: "red" }}> *</span></p>}
              <FormControl variant="outlined" className={classes.formControl} style={{ width: '100%'}}>
                <InputLabel id="borrower-type-select-outlined">Select One</InputLabel>
                {stateErrorMsg === '' && <Select
                  labelId="borrower-state-outlined-label"
                  id="borrower-state-select-outlined"
                  name="state"
                  color="primary"
                  label="Select One"
                  className={classes.inputStyle}
                  value={selectedState}
                  onChange={handleFormStateChange}
                  fullWidth >
                  {stateData.length !== 0 && stateData.map((item, index) => {
                    return (
                      <MenuItem value={item} key={(index - 1) + item.stateCode}>{item.stateName}</MenuItem>
                    )
                  })}
                </Select>}
              </FormControl>
            </Box> 
            </Grid>
                
            <Grid item xs={12} sm={6} md={6}>

              <Box className={classes.textareaSection}>
                <TextField
                  color="primary"
                  variant="outlined"
                  type="text"
                  name='firstName'
                  label={<Box>First Name <span style={{color: 'red'}}>*</span></Box>}
                  value={state.firstName}
                  onChange={(event) => handleNameChange(event)}
                  className={classes.textBox}
                  inputProps={{
                    maxLength: 80
                  }}
                />
              </Box>
              </Grid>
                <Grid item xs={12} sm={6} md={6}>
               <Box className={classes.textareaSection}>
                <TextField
                  color="primary"
                  variant="outlined"
                  type="text"
                  name='lastName'
                  label={<Box>Last Name <span style={{color: 'red'}}>*</span></Box>}
                  value={state.lastName}
                  onChange={(event) => handleNameChange(event)}
                  className={classes.textBox}
                   inputProps={{
                    maxLength: 20
                  }}
                />
              </Box>
              </Grid>

              <Grid item xs={12} sm={6} md={6}>

              <Box className={classes.textareaSection}>
                <TextField
                  color="primary"
                  variant="outlined"
                  type="text"
                  label={<Box>Phone Number <span style={{color: 'red'}}>*</span></Box>}
                  value={mobileNo}
                  onChange={(event) => {handleMobileNo(event); validateMobileNo(event)}}
                  className={classes.textBox}
                  inputProps={{
                    maxLength: 10
                  }}
                />
                {(mobileNoErr !== '') && <p className={classes.validationError}>{mobileNoErr}</p>}
              </Box>
              </Grid>
                <Grid item xs={12} sm={6} md={6}>
               <Box className={classes.textareaSection}>
                <TextField
                  color="primary"
                  variant="outlined"
                  type="text"
                  label="Email Address (Optional)"
                  value={emailId}
                  onChange={(event) => {handleEmailId(event); validateEmail(event)}}
                  className={classes.textBox}
                />
                 {(emailError !== '') && <p className={classes.validationError}>{emailError}</p>}
              </Box>
              </Grid>

              
              <Grid item xs={12} sm={6} md={6}>

               <FormControl variant="outlined" fullWidth>
                  <InputLabel className={classes.labelStyle} htmlFor="outlined-adornment-ssn">SSN Last 4 Digits  <span style={{ color: "red" }}>*</span></InputLabel>
                  <OutlinedInput
                    color="primary"
                    name="ssn"
                    id="outlined-adornment-ssn"
                    type={state.showssn ? 'text' : 'password'}
                    onChange={handleFormTextChange('ssn')}
                    value={state.ssn}
                    labelWidth={140}
                    inputProps={{
                      className: classes.inputStyle,
                      maxLength: 4
                    }}
                    endAdornment={
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle visibility"
                          onClick={handleClickShowPassword}
                          edge="end"
                        >
                          {state.showssn ? <Visibility /> : <VisibilityOff />}
                        </IconButton>
                      </InputAdornment>
                    }
                  
                  />
                </FormControl>
              </Grid>

              <Grid item xs={12} sm={6} md={6}>
                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                  <KeyboardDatePicker
                    fullWidth
                    color='primary'
                    autoOk={true}
                    disableToolbar
                    disableFuture
                    openTo="year"
                    views={["year", "month", "date"]}
                    format="MM/dd/yyyy"
                    variant="inline"
                    inputVariant="outlined"
                    label="Date of Birth"
                    value={inputDate}
                    placeholder='MM/DD/YYYY'
                    onChange={handleDateChange('inputDate')}
                    KeyboardButtonProps={{
                      'aria-label': 'change date',
                    }}
                    maxDate={new Date()}
                  />
                </MuiPickersUtilsProvider>
              </Grid>

              <Grid item xs={12} sm={12} md={12}>
                <Box className={classes.textareaSection}>
                <TextareaAutosize
                  style={{ height: '100px' }}
                  color="primary"
                  variant="outlined"
                  type="text"
                  name="comments"
                  maxLength="500"
                  onChange={(event) => handleCommment(event)}
                  value={additionalNote}
                  placeholder="Additional Notes (Optional)"
                  className={`${classes.textArea}`}
                >
              </TextareaAutosize>
                <Typography className={classes.textAreaValidation}>{calculateCommentLenth()}/500</Typography>
              </Box> 
              </Grid>
              </Grid>

              <Box>
              <Box>
                <FormGroup row>
                  <FormControlLabel
                      control={<Checkbox
                      checked={checkboxState}
                      onChange={(event) => checkboxChangeHandler(event)}
                      className={classes.checkboxContainer}
                      name="agree"
                  />}
                      label={<Typography className={classes.checkBoxLabel}> By checking this Box, you consent to being contacted by BSI for sales or marketing purposes. <span style={{ color: "red" }}>*</span></Typography>}
                      classes={{
                          label: classes.radioLabel
                      }}
                  />
                </FormGroup>
              </Box>     
              { !addDescriptionStatus && <Typography className={classes.viewconsent} onClick={() => addDescription()}>View Consent</Typography>}
              { addDescriptionStatus &&
                  <Box className={classes.infoTopBox}>
                    <Box style={{display: "flex"}}>
                      <Grid container>
                        <Grid item xs={11} md={11}>
                          <Typography className={classes.viewconsent} onClick={() => addDescription()}>Hide Consent </Typography>
                        </Grid>
                        <Grid item xs={1} md={1}>
                          <img src={close} className={classes.icon} onClick={() => addDescription()}/>
                        </Grid>
                      </Grid>
                    </Box>
                    <Typography className={classes.feelFree}>By providing my email address and mobile phone number, I am granting BSI, its subsidiaries, affiliates, partners, service providers, successors and assigns, express consent to contact me at that email address or phone number about my loan, including information regarding servicing and products or services offered by BSI or a joint-marketing partner in connection with my loan. My consent allows BSI to use text messaging, artificial or pre-recorded voice messages and automatic dialing technology, as well as emails, for informational and service calls or messages. Message and data rates may apply.</Typography>
                  </Box>
                } 
            </Box>
            {mandatoryFields && <Typography className={classes.errorMsg}>Please fill * required fields to submit.</Typography>}
            <Typography className={classes.errorMsg}>{errorMessage !== '' ? errorMessage : ''}</Typography>
            
            <Grid container mt={4}>
              <Grid item xs={12} sm={12}>
                <Box className={classes.buttonContainer} display="flex" justifyContent="center" style={{ paddingBottom: '20px', paddingTop: '20px' }}>
                  <Button className={classes.resetButton} mt={2}
                    variant="outlined"
                    onClick={() => handleCancel()}>
                    Cancel
                  </Button>                   

                  <Button className={classes.addAccButton} mt={2}
                    type="submit"
                    variant="contained"
                    color='primary'
                    disabled={loaderStatus || isAdminCheck()}
                    onClick={() => handleConfirm()}
                    >
                    {!loaderStatus ? 'Submit' : <CircularProgress color='primary' style={{ width: 25, height: 25 }} />}
                  </Button>
                </Box>
            </Grid>
            </Grid>
        </Box> :
         <>
          <Box className={classes.cardBody2}>
             <Typography className={classes.heading}>Thank you! Your request has been received.</Typography>
             <Typography className={classes.eligible}>If you are eligible for refinance or lending options, a member of our lending team will reach out to you.</Typography>
          </Box>
          
          <Box className={classes.gotItButton}>
            <Button
              variant='contained'
              color='primary'
              className={classes.btn}
              onClick={() => handleCancel(false)}
              >Got it</Button>
          </Box> 
          </>
        }
      </Box>
    </Dialog>
  )
}
